import { render, staticRenderFns } from "./WhatClientsSaySection.vue?vue&type=template&id=26bdb486&scoped=true&"
import script from "./WhatClientsSaySection.vue?vue&type=script&lang=js&"
export * from "./WhatClientsSaySection.vue?vue&type=script&lang=js&"
import style0 from "./WhatClientsSaySection.vue?vue&type=style&index=0&id=26bdb486&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bdb486",
  null
  
)

export default component.exports